import {ReactElement, ReactNode} from 'react';
import {cn} from '@chekin/guestapp-ui-kit';
import {WhyDataRequired} from 'components/WhyDataRequired';
import {GroupTitle, Fields, FieldsGroupVariant} from './styled';

type Props = {
  title: string;
  children: ReactElement | ReactElement[] | ReactNode | undefined;
  centered?: boolean;
  withWhyDataRequired?: boolean;
  variant?: FieldsGroupVariant;
};
export const FieldsGroup = ({
  title,
  centered = true,
  children,
  withWhyDataRequired,
  variant = 'default',
}: Props) => {
  return (
    <>
      <GroupTitle
        $variant={variant}
        className={cn(
          'fields-group-title',
          'kiosko:text-kiosko-m kiosko:mb-10 kiosko:py-5',
        )}
      >
        <span>{title}</span> {withWhyDataRequired && <WhyDataRequired />}
      </GroupTitle>
      <Fields
        className="fields-group"
        $centered={centered}
        $variant={variant}
        data-variant={variant}
      >
        {children}
      </Fields>
    </>
  );
};
